// ts-nocheck
import { Carousel } from "primereact/carousel";

import { ContentCard } from "sj-ui-toolkit/src/atlas/components";
import { buildResponsiveOptions } from "sj-ui-toolkit/src/helpers";

import { useSavedLessons } from "../../../../featureFlags";

const lowestThreshold = 650;
const interval = 350;
const maxCards = 6;

export const SavedLessons = ({ savedLessons }) => {
  const savedLessonsEnabled = useSavedLessons();

  const responsiveOptions = buildResponsiveOptions({ lowestThreshold, maxCards, interval });

  if (!savedLessonsEnabled) {
    return null;
  }

  // TODO: build out empty state with FF on
  if (!savedLessons || savedLessons.length === 0) {
    return null;
  }

  return (
    <div className="mt-8">
      <h2 className="atlas-h5 pb-4">My Saved Lessons</h2>
      <Carousel
        aria-label="Saved Lessons"
        value={savedLessons}
        responsiveOptions={responsiveOptions}
        numVisible={4}
        numScroll={1}
        showNavigators={true}
        itemTemplate={(lesson, index) => <ContentCard key={index} {...lesson} />}
      />
    </div>
  );
};
